import { render, staticRenderFns } from "./hw-h5.vue?vue&type=template&id=c8b53ab0"
import script from "./hw-h5.vue?vue&type=script&lang=js"
export * from "./hw-h5.vue?vue&type=script&lang=js"
import style0 from "./hw-h5.vue?vue&type=style&index=0&id=c8b53ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports